import { motion } from 'framer-motion';
import {
  MapPin, FileText, CreditCard, BarChart3, Clock, Shield, ExternalLink
} from 'lucide-react';

const portalFeatures = [
  { icon: MapPin, text: 'Real-Time GPS Tracking' },
  { icon: FileText, text: 'Invoice & BOL Access' },
  { icon: CreditCard, text: 'Payment History' },
  { icon: BarChart3, text: 'Shipping Analytics' },
  { icon: Clock, text: '24/7 Self-Service' },
  { icon: Shield, text: 'Bank-Grade Encryption' },
];

export const CustomerPortalSection = () => (
  <section className="py-24 bg-zinc-950 border-t border-zinc-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-red-500 text-xs font-bold uppercase tracking-[0.25em]">For Shippers</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white mt-3 mb-4 tracking-tight">
            Your Shipments.<br />Total Visibility.
          </h2>
          <p className="text-zinc-400 text-lg mb-10 max-w-lg" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            Our customer portal gives you complete control — track loads in real-time, 
            access invoices, and manage your entire freight operation from one dashboard.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mb-10">
            {portalFeatures.map(item => (
              <div key={item.text} className="flex items-center gap-3 group">
                <div className="w-10 h-10 bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-red-600/40 transition-colors">
                  <item.icon className="w-5 h-5 text-red-500" strokeWidth={1.5} />
                </div>
                <span className="text-zinc-300 text-sm font-medium" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>{item.text}</span>
              </div>
            ))}
          </div>
          <a
            href="https://tms.redballxpress.us/clientportal/login"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold uppercase tracking-wider text-sm transition-all hover:-translate-y-0.5"
            data-testid="customer-portal-btn"
          >
            Access Customer Portal
            <ExternalLink className="w-4 h-4" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="hidden lg:block"
        >
          <div className="relative">
            <div className="absolute -inset-4 bg-red-600/5 blur-3xl rounded-full" />
            <img
              src="https://static.prod-images.emergentagent.com/jobs/67b0925b-7f4b-4cc2-900d-1c317dc2d0bd/images/49cd7d5d9e3c23cf932ecd73c1d845595175d84c481092d3ed38bca7f0e0eb03.png"
              alt="Customer Portal Dashboard"
              className="relative w-full border border-zinc-800 shadow-2xl shadow-black/50"
            />
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
